import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiPaths } from '../api/urls';
import { environment } from 'src/environments/environment';
import { Observable, throwError, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  calendarEventsSubject = new Subject<any>();

  constructor(private http: HttpClient) {
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `${error.error}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  getEventTypes(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/${ApiPaths.eventTypes}`)
      .pipe(
        catchError(this.handleError)
      );
  }

  addEvent(event: any): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}/${ApiPaths.events}`, event, { observe: 'response' as any })
      .pipe(
        catchError(this.handleError)
      );
  }

  updateEvent(event: any, eventID: number): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/${ApiPaths.events}/${eventID}`,
      event, { observe: 'response' as any })
      .pipe(
        catchError(this.handleError)
      );
  }

  deleteEvent(eventID: number): Observable<any> {
    return this.http.delete<any>(`${environment.baseUrl}/${ApiPaths.events}/${eventID}`,
      { observe: 'response' as any })
      .pipe(
        catchError(this.handleError)
      );
  }

  getEvents(parametters: any): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/${ApiPaths.events}`, {
      params: { ...parametters },
      observe: 'response' as any
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  getCalendarDays(parametters: any): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/${ApiPaths.calendarDays}`, {
      params: { ...parametters },
      observe: 'response' as any
    })
      .pipe(
        catchError(this.handleError)
      );
  }

  getEvent(eventID: number): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/${ApiPaths.events}/${eventID}`,
      { observe: 'response' as any })
      .pipe(
        catchError(this.handleError)
      );
  }

  CompleteEventWithConfNumber(eventID: number, confirmationNumber: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/${ApiPaths.events}/${eventID}/complete`, confirmationNumber,
      { observe: 'response' as any })
      .pipe(
        catchError(this.handleError)
      );
  }

  CompleteEvent(eventID: number): Observable<any> {
    const url = `${environment.baseUrl}/${ApiPaths.events}/${eventID}/complete`;
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      observe: 'response' as 'body'
    };
  
    return this.http.put<any>(url, {}, options)
      .pipe(
        catchError(this.handleError)
      );
  }
}

